import React from "react";
import {AssetDetailKvColgroupFour} from "../../../components/detailLayout/detailKvColgroup";

function ReportCodeFormTable({children}) {
    return (
        <table className="user-account-edit-form__table report-code-form-table">
            <AssetDetailKvColgroupFour />
            {children}
        </table>
    );
}

export default ReportCodeFormTable;
